// extracted by mini-css-extract-plugin
export default {"select":"AddressSelect_select__UyuDr","label":"AddressSelect_label__qQVAK"};